module.exports = __webpack_public_path__ + "img/mist.40985d9e.svg";